import { HttpParams } from "@angular/common/http";
import { FormGroup } from "@angular/forms";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { isDate, isValid } from "date-fns";

export class Utility {
  // static URL_REGEXP = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
  static URL_REGEXP = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;
  static internalPhoneRegex = /^(?!(?:\D*0)+\D*$)[0-9]{1,11}/;
  static mobileRegex = /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/;


  static isValidEmail(email: string) {
    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if (!EMAIL_REGEXP.test(email)) {
      return false;
    }
    return true;
  }

  static findRecursiveById(array: any, id: any) {
    var result;
    array.some((o: any) => result = o.id === id ? o : this.findRecursiveById(o.children || [], id));
    return result;
  };

  static getLastMonths(monthCount: any) {
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let today = new Date();
    let d;
    let month;
    let year;
    let months: string[] = [];
    for (let i = monthCount; i > 0; i -= 1) {
      d = new Date(today.getFullYear(), today.getMonth() + 1 - i, 1);
      month = monthNames[d.getMonth()];
      year = d.getFullYear();
      months.push(`${month} ${year} `);
    }
    return months;
  }

  static getCurrentMonth() {
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let today = new Date();
    return monthNames[today.getMonth()];
  }


  static convertByteSize(bytes: number) {
    const dp = 1;
    const thresh = 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }

    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    const r = 10 ** dp;

    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(dp) + ' ' + units[u];
  }

  static isPhoto(fileName: string) {
    const extention = ['.jpg', '.gif', '.png', '.bmp', '.png', '.jpeg'];
    return (new RegExp('(' + extention.join('|').replace(/\./g, '\\.') + ')$')).test(fileName.toLowerCase());
  }

  static isValidMobileNumber(number: string) {
    var regex = new RegExp('^(\\+98|0)?9\\d{9}$');
    return regex.test(number);
  }

  static fixDigits(input: any) {
    const
      persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
      arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

    if (typeof input === 'string') {
      for (let i = 0; i < 10; i++) {
        input = input.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return input;

  }

  static getFileType(fileName: string) {
    let checkFileType = fileName.split('.').pop();
    var fileType;
    if (checkFileType == "txt") {
      fileType = "text/plain";
    }
    if (checkFileType == "pdf") {
      fileType = "application/pdf";
    }
    if (checkFileType == "doc") {
      fileType = "application/vnd.ms-word";
    }
    if (checkFileType == "docx") {
      fileType = "application/vnd.ms-word";
    }
    if (checkFileType == "xls") {
      fileType = "application/vnd.ms-excel";
    }
    if (checkFileType == "png") {
      fileType = "image/png";
    }
    if (checkFileType == "jpg") {
      fileType = "image/jpeg";
    }
    if (checkFileType == "jpeg") {
      fileType = "image/jpeg";
    }
    if (checkFileType == "gif") {
      fileType = "image/gif";
    }
    if (checkFileType == "csv") {
      fileType = "text/csv";
    }
    if (checkFileType == "apk") {
      fileType = "application/vnd.android.package-archive";
    }
    if (checkFileType == "pptx") {
      fileType = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    }

    return fileType;
  }

  static generateRandomColors(number: number): string[] {
    let result: string[] = [];
    for (let index = 0; index < number; index++) {
      let color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
      result.push(color);
    }
    return result;
  }


  static isArray(value: any) {
    if (Array.isArray && Array.isArray(value)) {
      return true;
    }
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') {
      return true;
    }
    return false;
  }

  static isObject(value: any) {
    return typeof value === 'object';
  }

  static convertToJalali(value: any, format: string = 'YYYY-MM-DD HH:mm:SS') {
    let formatOptions: any = {
      timeZone: 'Asia/Tehran'
    };

    let t = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|YYYY|YY|HH?|mm?|SS?S?|.)/g;

    let mathes = format.match(t);

    if (mathes)
      for (let index = 0; index < mathes.length; index++) {
        switch (mathes[index]) {
          case 'YYYY':
            formatOptions.year = 'numeric';
            break;
          case 'YY':
            formatOptions.year = '2-digit';
            break;
          case 'MM':
            formatOptions.month = '2-digit';
            break;
          case 'MMM':
            formatOptions.month = 'short';
            break;
          case 'MMMM':
            formatOptions.month = 'long';
            break;
          case 'DD':
            formatOptions.day = '2-digit';
            break;
          case 'DDD':
            formatOptions.weekday = 'short';
            break;
          case 'DDDD':
            formatOptions.weekday = 'long';
            break;
          case 'HH':
            formatOptions.hour = 'numeric';
            break;
          case 'mm':
            formatOptions.minute = 'numeric';
            break;
          case 'SS':
            formatOptions.second = 'numeric';
            break;
          default:
            break;
        }
      }

    if (typeof value === 'string') {
      return Utility.fixDigits(new Intl.DateTimeFormat('fa-IR', formatOptions).format(new Date(value)));
    }

    return Utility.fixDigits(new Intl.DateTimeFormat('fa-IR', formatOptions).format(value));
  }

  static isMobileOrTablet(userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera): boolean {
    // tslint:disable-next-line:max-line-length
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4));
  }

  static convertToNgbDate(date: Date): NgbDateStruct {
    return <NgbDateStruct>{ year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }
  }

  static convertToJalaliNgbDate(date: Date, format: string = 'YYYY-MM-DD'): NgbDateStruct | null {
    if (date.toString() === "0001-01-01T00:00:00") return null;
    let d = new Date(Utility.convertToJalali(date, format));
    return <NgbDateStruct>{ year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() }
  }

  static convertNgbDateStructToString(dateStruct: any, time: { hour: number, minute: number, second: number } | null, seperator: string = '/'): string {
    if (!dateStruct) {
      return '';
    }

    if (time)
      return `${dateStruct.year}${seperator}${dateStruct.month}${seperator}${dateStruct.day} ${time.hour.toString().padStart(2, '0')}:${time.minute.toString().padStart(2, '0')}`;

    return `${dateStruct.year}${seperator}${dateStruct.month}${seperator}${dateStruct.day}`;
  }

  // static convertNgbDateStructToGregorianString(dateStruct: any, local: string = 'fa'): string {
  //   if (!dateStruct) {
  //     return '';
  //   }

  //   if (local == 'fa') {
  //     var gd = jalali.toGregorian(dateStruct.year, dateStruct.month, dateStruct.day);
  //     return `${gd.gy}/${gd.gm}/${gd.gd}`;
  //   }

  //   return new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day).toUTCString();
  // }

  static addUTCDesignatorRecurse(value: any) {
    if (this.isArray(value)) {
      value.forEach((x: any) => {
        for (var property in x) {
          if (x.hasOwnProperty(property)) {
            if (typeof x[property] === 'string' && isDate(new Date(x[property])) && isValid(new Date(x[property]))) {
              x[property] = this.addUTCDesignator(x[property]);
            }

            else if (Utility.isArray(x[property])) {
              Utility.addUTCDesignatorRecurse(x[property]);
            }
            else if (this.isObject(x[property])) {
              Utility.addUTCDesignatorRecurse(x[property]);
            }
          }
        }
      })
    } else if (this.isObject(value)) {
      for (const property in value) {
        if (value.hasOwnProperty(property)) {
          if (typeof value[property] === 'string' && Number.isNaN(parseFloat(value[property])) && isDate(new Date(value[property])) && isValid(new Date(value[property]))) {
            value[property] = this.addUTCDesignator(value[property])
          }

          else if (Utility.isArray(value[property])) {
            Utility.addUTCDesignatorRecurse(value[property]);
          }
        }
      }
    }
  }

  static addUTCDesignator(date: any) {
    if (typeof date == 'string') {
      date = process(date);
    } else if (Utility.isArray(date)) {
      date.forEach((d: any) => {
        d = process(d);
      });
    }

    return date;

    function process(d: any) {
      if (d && d != '0001-01-01') {
        if (!d.endsWith('z') && !d.endsWith('Z')) {
          d = d + 'Z';
        }
      }

      return d;
    }
  }

  static parseSecondsToDHMS(value: any) {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var days = Math.floor(sec_num / 3600 / 24);
    var hours = Math.floor((sec_num - days * 3600 * 24) / 3600);
    var minutes = Math.floor((sec_num - (days * 3600 * 24) - (hours * 3600)) / 60);
    var seconds = sec_num - (days * 3600 * 24) - (hours * 3600) - (minutes * 60);

    return { days, hours, minutes, seconds };
  }

  static parseSecondsToHMS(value: any) {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    return { hours, minutes, seconds };
  }

  static stripHtml(html: string) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    let stripped = tmp.textContent || tmp.innerText || "";
    tmp.remove();
    return stripped;
  }

  static convertToGregorian(year: number, month: number, day: number, op: any = {}) {
    const formatOut = (gD: any) => "toCal" in op ? (op.calendar = op.toCal, new Intl.DateTimeFormat(op.locale ?? "en", op).format(gD)) : gD,
      dFormat = new Intl.DateTimeFormat('en-u-ca-persian', { dateStyle: 'short', timeZone: "UTC" });
    let gD = new Date(Date.UTC(2000, month, day));
    gD = new Date(gD.setUTCDate(gD.getUTCDate() + 226867));
    const gY = gD.getUTCFullYear() - 2000 + year;
    gD = new Date(((gY < 0) ? "-" : "+") + ("00000" + Math.abs(gY)).slice(-6) + "-" + ("0" + (gD.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + (gD.getUTCDate())).slice(-2));
    let [pM, pD, pY] = [...dFormat.format(gD).split("/")], i = 0;
    gD = new Date(gD.setUTCDate(gD.getUTCDate() +
      ~~(year * 365.25 + month * 30.44 + day - (+pY.split(" ")[0] * 365.25 + +pM * 30.44 + +pD * 1)) - 2));
    while (i < 4) {
      [pM, pD, pY] = [...dFormat.format(gD).split("/")];
      if (+pD == day && +pM == month && +pY.split(" ")[0] == year) return formatOut(gD);
      gD = new Date(gD.setUTCDate(gD.getUTCDate() + 1));
      i++;
    }
    throw new Error('Invalid Persian Date!');
  }


  static objectToFormData(obj: any, form: FormData | null = null, namespace: string = ''): FormData {
    var fd = form || new FormData();
    var formKey;
    for (var property in obj) {
      if (obj.hasOwnProperty(property)) {
        if (namespace) {
          if (obj[property] instanceof File || isNaN(parseInt(property))) {
            formKey = namespace + '.' + property;
          } else {
            formKey = namespace + '[' + property + ']';
          }
        } else {
          formKey = property;
        }
        if (typeof obj[property] === 'object' && (obj[property]?.year)) {
          let d = (Utility.convertNgbDateStructToString(obj[property], null));
          fd.append(formKey, d);
        } else if (obj[property] instanceof FileList || (this.isArray(obj[property]) && obj[property][0] instanceof File)) {
          let files = obj[property];
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            fd.append(formKey, file, file.name);
          }
        }
        // Handle arrays of primitive types (numbers, strings, etc.) for ASP.NET Core model binding
        else if (this.isArray(obj[property])) {
          let arr = obj[property];
          // Check if array contains primitive values or files
          if (arr.length === 0 || typeof arr[0] !== 'object' || arr[0] instanceof File) {
            // For ASP.NET Core [FromForm] binding with List<T>, use indexed notation
            for (let i = 0; i < arr.length; i++) {
              // Use indexed notation: propertyName[0], propertyName[1], etc.
              fd.append(`${formKey}[${i}]`, arr[i]?.toString() || '');
            }
          } else {
            // Array of complex objects - recurse
            this.objectToFormData(obj[property], fd, formKey);
          }
        }
        else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
          this.objectToFormData(obj[property], fd, formKey);
        }
        else {
          // if it's a string or a File object
          fd.append(formKey, obj[property]);
        }
      }
    }
    return fd;
  };

  static tableStateToHttpParams(tableState: any): HttpParams {
    let params = new HttpParams();

    for (const [k, v] of Object.entries(tableState)) {
      if (k == 'filter') {
        for (const [i, j] of Object.entries(tableState.filter)) {
          if (j instanceof Array) {
            for (let p = 0; p < j.length; p++) {
              params = params.append(`filter.${i}[${p}]`, j[p]);
            }
          } else {
            params = params.append(`filter.${i}`, <any>j);
          }
        }
      } else if (k == 'paginator') {
        for (const [i, j] of Object.entries(tableState.paginator)) {
          params = params.append(`paginator.${i}`, <any>j);
        }
      } else if (k == 'sorting' && tableState.sorting) {
        for (const [i, j] of Object.entries(tableState.sorting)) {
          params = params.append(`sorting.${i}`, <any>j);
        }
      } else if (k == 'grouping' && tableState.grouping) {
        for (const [i, j] of Object.entries(tableState.grouping)) {
          if (j instanceof Array) {
            for (let p = 0; p < j.length; p++) {
              params = params.append(`grouping.${i}[${p}]`, j[p]);
            }
          } else if (j instanceof Set) {
            j.forEach(p => {
              params = params.append(`grouping.${i}[${p}]`, p);
            })
          } else {
            params = params.append(`grouping.${i}`, <any>j);
          }
        }
      } else {
        params = params.append(k, <any>v);
      }
    }

    return params;
  }

  static isControlInvalid(form: FormGroup, controlName: string): boolean {
    const control = form.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  static addScript(src: string) {
    let script = document.createElement('script');
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');
    script.setAttribute('src', src);
    document.documentElement.firstChild?.appendChild(script);
  }

  static findContainment(element: any, container: any) {

    /*
    Obtain the bounding rectangle for each element
    */
    const brE = element.getBoundingClientRect()
    const brC = container.getBoundingClientRect()

    /*
    If the boundaries of container pass through the boundaries of
    element then classifiy this as an overlap
    */
    if (
      /* Does container left or right edge pass through element? */
      (brE.left < brC.left && brE.right > brC.left) ||
      (brE.left < brC.right && brE.right > brC.right) ||
      /* Does container top or bottom edge pass through element? */
      (brE.top < brC.top && brE.bottom > brC.top) ||
      (brE.top < brC.bottom && brE.bottom > brC.bottom)) {

      return "overlap";
    }

    /*
    If boundaries of element fully contained inside bounday of
    container, classify this as containment of element in container
    */
    if (
      brE.left >= brC.left &&
      brE.top >= brC.top &&
      brE.bottom <= brC.bottom &&
      brE.right <= brC.right
    ) {
      return "contained"
    }

    /*
    Otherwise, the element is fully outside the container
    */
    return "outside"

  }

  static adjustColor(c: any, a: any) { return c?.replace(/\w\w/g, (m: any) => Math.min(255, Math.max(0, parseInt(m, 16) + a)).toString(16)) }

}



export const customEditorConfig = {
  sanitize: false,
  editable: true,
  defaultParagraphSeparator: 'p',
  defaultFontName: 'Yekan',
  fonts: [
    { class: 'Yekan', name: 'Yekan' },
  ],
  customClasses: [
    {
      name: 'text-right',
      class: 'text-right',
    },
  ],
  toolbarHiddenButtons: [
    [
      'subscript',
      'superscript',
      'indent',
      'outdent',
      'fontName'
    ],
    [
      'fontSize',
      'customClasses',
      'insertImage',
      'insertVideo',
      'insertHorizontalRule',
      'removeFormat',
      'toggleEditorMode'
    ]
  ]
}

export const editorFormats = [
  'background',
  'bold',
  'color',
  'font',
  'code',
  'italic',
  'link',
  'size',
  'strike',
  'script',
  'underline',
  'blockquote',
  'header',
  'indent',
  'list',
  'align',
  'direction',
  'code-block',
  'formula'
  // 'image'
  // 'video'
];


